<template>
    <b-container fluid class="">
        <b-row class="justify-content-between flex-center py-2">
            <b-col cols="12" md="6" class="w-100">
                <h3>{{ $t('sales.title') }}</h3>
            </b-col>
            <b-col cols="12" md="6" lg="6" xl="4">
                <b-input-group class="w-100 my-2" :prepend="$t('ticket_scan.button')">
                    <b-form-input type="text" v-model="searchText"></b-form-input>
                    <b-input-group-append>
                        <b-btn><span class="fa fa-search"></span></b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <hr/>
        

        <!-- <b-row v-if="events">
            <b-col>
                <events-table position
                              search-key="name"
                              :items="events"
                              :fields="eventsFields"
                              @rowClicked="goToUserEventSales">
                </events-table>
            </b-col>
        </b-row> -->

    <b-container fluid class="p-2">
        <b-row class="w-100 noMargin noPadding justify-content-center">
            <b-col cols="12" md="3" class="eventDash m-2 p-4 shadow-lg" v-for="event in filterItems" @click="goToUserSelection(event.id)" v-b-popover.hover.right="$t('hover.msg')">
                <b-row style="margin-bottom: 5%">
                    <b-col cols="6"><h6 class="text-left"> {{ event.name }} </h6></b-col>
                    <b-col cols="6"><b-badge pill  variant="info" class="float-right">
                        <i class="fas fa-calendar-day mr-1"></i>{{ event.date | moment('DD.MM.YYYY') }}</b-badge></b-col>
                </b-row>
                <!-- <p class="text-right" style="background: rgb(97, 144, 231)"> {{ event.date | moment('DD.MM.YYYY') }} </p> -->
                
                <!-- <hr style="background-color:#FFF;"/> -->
                <b-row>
                    <b-col cols="9">
                        <h4  v-b-popover.hover.left="$t('sales.sold')">{{ event.total_sold }}</h4>
                        <p v-b-popover.hover.left="$t('sales.total')" style="color: grey">{{ event.total_tickets }}</p>
                    </b-col>
                    <b-col cols="3" style="color: grey"><p>{{calculatePercentage(event.total_sold, event.total_tickets)}}%</p></b-col>
                </b-row>
                <b-progress :value="calculatePercentage(event.total_sold, event.total_tickets)" variant="info" striped :animated="animate" class="mt-2"></b-progress>
            </b-col>
        </b-row>
    </b-container>


    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'dashboardEvent',
        data() {
            return {
                animate: true,
                user: {},
                searchText: "",
                events: [],
                eventsFields: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'total_tickets',
                        label: 'Tickets assigned',
                        sortable: true
                    },
                    {
                        key: 'total_sold',
                        label: 'Tickets sold',
                        sortable: true,
                    },
                ],

            }
        },
        computed: {
            filterItems() {
                if (this.events) {
                    return this.events.filter(event => {
                        return event['name'].toLowerCase().includes(this.searchText.toLowerCase());
                    });
                } else {
                    return this.events;
                }
            }
        },
        methods: {
            
            calculatePercentage(sold, total){
                if(sold == 0 || total == 0){
                    return 0;
                }
                return parseInt((sold/total)*100);
            },
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            getEvents(){
                this.$axios.get('sales/events').then(response => {
                    if (response.data.success) {
                        this.events = response.data.data;
                    }else{
                         this.$toasted.global.err({
                        message : this.$t(response.data.data.msg)
                            });
                    }
                })
            },
            goToUserSelection(id){
                 this.$router.push('/sales/'+ id + '/users')
            },
        
        },
        created() {
            let self = this;
            this.getEvents();
            this.interval = setInterval(function () {
                self.getEvents();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>

<style  lang="scss">
    .sectorsRow{
        height: 30vh;
    }
    .sectorsRow2{
        height: 15vh;
    }
    .sectorDash {
        color: #FFF;
        height: 15vh;
        background-image: url('../../assets/img/login.jpg') !important;
        border: 5px solid #FFF;
        border-radius: 10px;

        &:hover {
            cursor: pointer;
            background: #455A64;
        }
    }

    .sectorDashDis {
        height: 15vh;
        color: #FFF;
        background: #455A64 !important;
        border: 5px solid #FFF;
        border-radius: 10px;

        &:hover {
            cursor: pointer;
            background: #455A64;
        }
    }

    .footballField {

    }
</style>